/**
 * The settings file contains configurations that are used across the entire application.
 */
const VERSION = '1.0.0';
const BUILD_ENV = 2;
const BUILD_ENVS = {
  DEV: 1,
  STG: 2,
  PROD: 3
}

const getBasePath = () => {
  switch (BUILD_ENV) {
    case BUILD_ENVS.DEV: return '/';
    case BUILD_ENVS.STG: return '/stg_ag/';
    case BUILD_ENVS.PROD: return '/ag/';
    default: return '/';
  }
}

const getManagementServiceUrl = () => {
  switch (BUILD_ENV) {
    case BUILD_ENVS.DEV: return 'http://localhost:3333';
    case BUILD_ENVS.STG: return 'https://voceagente.fiocruz.br/stg/management';
    case BUILD_ENVS.PROD: return 'https://voceagente.fiocruz.br/api/management';
    default: return 'http://localhost:3333';
  }
}

const getAuthServiceUrl = () => {
  switch (BUILD_ENV) {
    case BUILD_ENVS.DEV: return 'http://localhost:3334';
    case BUILD_ENVS.STG: return 'https://voceagente.fiocruz.br/stg/auth';
    case BUILD_ENVS.PROD: return 'https://voceagente.fiocruz.br/api/auth';
    default: return 'http://localhost:3334';
  }
}

const settings = {
  VERSION,
  BUILD_ENV: BUILD_ENV,
  BUILD_ENVS: BUILD_ENVS,
  IS_DEBUG_ENABLED: true,
  MANAGEMENT_SERVICE_URL: getManagementServiceUrl(),
  AUTH_SERVICE_URL: getAuthServiceUrl(),
  BASE_PATH_IMAGES_FOLDER: `${getBasePath()}images`,
  DEFAULT_MAP_LOCATION: {
    lat: -17.7401071,
    lng: -53.7139307,
    zoom: 4,
  },
  DEFAULT_MAP_ZOOM_CLOSE: 13,
  DEFAULT_MAP_ZOOM_FAR: 4,
  CURRENT_COUNTRY_ID: 21, // Brazil
  runningOnDev: () => this.BUILD_ENV === this.BUILD_ENVS.DEV,
  getBasePath: getBasePath,
};

export default settings;
